module.exports = __webpack_public_path__ + "fb5a31a9.svg";